import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { SportProviderMappingDto } from "@/types/ApiResponses/Sport";

export interface GetSportMappingsParams {
  providerId?: number;
}

export const getSportMappings = async (
  sportId: number,
  props: QueryProps<GetSportMappingsParams>
): Promise<SportProviderMappingDto[]> => {
  const res = await api.client.get(`/sports-new/${sportId}/mappings`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
